export default "__VITE_ASSET__DNSKp7R2__"